import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { EcrService } from '../../service';

export type ImageScanningConfiguredConfig = typeof ImageScanningConfiguredConfig._.Config;

export const ImageScanningConfiguredConfig = IntegrationConfig.make({
  service: EcrService,
  name: Integration_Handler_Names_Enum.ImageScanningConfigured,
  configSchema: z.object({
    repositoryNames: z.array(z.string().min(1)).min(1),
  }),
});
